import React from "react";
import { useNavigate } from "react-router-dom";

const Carousel = () => {
    const navigate = useNavigate();

    return <div className="bg-[#08206B] h-full w-full flex justify-center items-center">
        <h1 className="text-white text-2xl md:text-4xl font-bold cursor-pointer" onClick={() => navigate("/")}>Kazi Agency</h1>
    </div>;
};

export default Carousel;